/**
 * Combine a listing's own photos with the photos inherited from its associated
 * property, for display. Listing photos come first; property photos are appended
 * and de-duplicated (a URL never appears twice). House/room photos are otherwise
 * separate sets — nothing is copied between them.
 */
export function mergeListingImages(
  listingPictures?: string[] | null,
  propertyImages?: string[] | null,
): string[] {
  return Array.from(
    new Set([...(listingPictures ?? []), ...(propertyImages ?? [])]),
  );
}
